import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CustomTag from '@components/CustomTag';
import useUpload from '../Upload';

interface IActivationUploadStep {
  translate: any;
  actionKey: any;
  setUploadedDevices: any;
}

const useNetworkBlockUploadStep = ({
  actionKey,
  setUploadedDevices,
}: IActivationUploadStep) => {
  const { t: translate } = useTranslation(['device-actions-modal']);

  const customInfo = useMemo(
    () => (
      <div style={{ padding: '8px' }}>
        <div>{translate('steps.network-block.blocking-types')}</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '6px' }}>
          <div style={{ flex: '1' }}>
            <span style={{ whiteSpace: 'nowrap' }}>
              <CustomTag>1</CustomTag>
              <b>
                <span style={{ marginRight: '6px' }}>-</span>
                {`${translate('steps.network-block.blocking-type-permanent')}`}
              </b>
            </span>
            <div style={{ color: 'var(--red-color)', fontSize: '0.75rem' }}>
              {`*MSISDN, ${translate('steps.network-block.block-type')}`}
            </div>
          </div>
          <div style={{ flex: '2' }}>
            {` ${translate('steps.network-block.blocking-type-permanent-exp')}`}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '5px',
          }}
        >
          <div style={{ flex: '1' }}>
            <span style={{ whiteSpace: 'nowrap' }}>
              <CustomTag>2</CustomTag>
              <b>
                <span style={{ marginRight: '6px' }}>-</span>
                {`${translate('steps.network-block.blocking-type-renew')}`}
              </b>
            </span>

            <div style={{ color: 'var(--red-color)', fontSize: '0.75rem' }}>
              {`*MSISDN, ${translate('steps.network-block.block-type')}`}
            </div>
          </div>

          <div style={{ flex: '2' }}>
            {` ${translate('steps.network-block.blocking-type-renew-exp')}`}
          </div>
        </div>
        <div
          style={{
            flexWrap: 'wrap',
            display: 'flex',
            marginTop: '5px',
          }}
        >
          <div style={{ flex: '1' }}>
            <span style={{ whiteSpace: 'nowrap' }}>
              <CustomTag>3</CustomTag>
              <b>
                <span style={{ marginRight: '6px' }}>-</span>
                {`${translate('steps.network-block.blocking-type-temporary')}`}
              </b>
            </span>
            <div style={{ color: 'var(--red-color)', fontSize: '0.75rem' }}>
              {`*MSISDN, ${translate(
                'steps.network-block.block-type',
              )}, ${translate('steps.network-block.end-validity')}`}
            </div>
          </div>
          <div style={{ flex: '2' }}>
            {` ${translate('steps.network-block.blocking-type-temporary-exp')}`}
          </div>
        </div>
      </div>
    ),
    [translate],
  );

  const { uploadStep, uploadReinitState } = useUpload({
    actionKey,
    setUploadedDevices,
    customInfo: actionKey === 20 ? customInfo : undefined,
  });

  return useMemo(() => {
    return {
      uploadReinitState,
      step: {
        ...uploadStep,
      },
    };
  }, [uploadReinitState, uploadStep]);
};

export default useNetworkBlockUploadStep;
